module.exports = __webpack_public_path__ + "static/media/close.e7e2502b.svg";